import React from "react";
import StartProjectModal from "./components/StartProjectModal";

type RegistryComponent = React.ComponentType<unknown>;

const asRegistryComponent = <P,>(
  Component: React.ComponentType<P>
): RegistryComponent => Component as RegistryComponent;

export const componentRegistry: Record<string, RegistryComponent> = {
  StartProjectModal: asRegistryComponent(StartProjectModal),
};
